if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButtons = Array.from(this.querySelectorAll('[type="submit"]'));
      if (document.querySelector('cart-drawer')) this.submitButtons.forEach(button => button.setAttribute('aria-haspopup', 'dialog'));
    }

    onSubmitHandler(evt) {
      console.log('event', evt)
      evt.preventDefault();

      this.handleErrorMessage();
      this.submitButtons = Array.from(this.querySelectorAll('[type="submit"]'));
      evt.submitter.classList.add('loading')
      evt.submitter.setAttribute('aria-disabled', true)
      evt.submitter.querySelectorAll('.loading-overlay__spinner').forEach(loader => {
        loader.classList.remove('hidden')
      });

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (evt.submitter.name === 'pre-order') {
        delete formData.id
        delete formData['product-id']

        formData.append('id', evt.submitter.dataset.preOrderVariant)
        formData.append('product-id', evt.submitter.dataset.preOrderProductId)
        formData.append('properties[_preOrder]', 'true')
        formData.append('properties[Pre-Order]', evt.submitter.dataset.preOrderText)
      }

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            this.submitButtons.forEach(button => {
              const soldOutMessage = button.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              button.setAttribute('aria-disabled', true);
              button.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            })
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButtons.forEach(button => button.classList.remove('loading'));
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButtons.forEach(button => button.removeAttribute('aria-disabled'));
          this.querySelectorAll('.loading-overlay__spinner').forEach(loader => {
            loader.classList.add('hidden')
          });
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}


if (!customElements.get('product-atc-sticky')) {
  class ProductAtcSticky extends HTMLElement {
    constructor() {
      super()
      this.mainButton = document.querySelector('.product-form__submit')

      window.addEventListener('scroll', this.onScroll.bind(this), { passive: false })
    }

    connectedCallback() {
      this.stickyHandler()
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll.bind(this))
    }

    onScroll(e) {
      this.stickyHandler()
    }

    stickyHandler() {
      const mainButtonTop = this.mainButton.getBoundingClientRect().top
      if (this.elementIsVisibleInViewport(this.mainButton, true) || mainButtonTop > 50) {
        this.classList.add('is-hidden')
      } else {
        this.classList.remove('is-hidden')
      }
    }

    elementIsVisibleInViewport (el, partiallyVisible = false) {
      const { top, left, bottom, right } = el.getBoundingClientRect();
      const { innerHeight, innerWidth } = window;
      return partiallyVisible
        ? ((top > 0 && top < innerHeight) ||
            (bottom > 0 && bottom < innerHeight)) &&
            ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
        : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
    };
  }

  customElements.define('product-atc-sticky', ProductAtcSticky)
}